import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useActivityFeed(query: Record<string, string> = {}) {
  return useQuery({
    queryKey: ['activity-feed', query],
    queryFn: () => apiClient.listActivityFeed(query),
    refetchInterval: 60000,
  });
}
